import layout from '@/layout/index'
import chargingMonitor from '@/module/operatingCenter/page/chargingMonitor'
import siteMonitor from '@/module/operatingCenter/page/siteMonitor'
import deviceControl from '@/module/operatingCenter/page/deviceControl'
import videoMinitor from '@/module/operatingCenter/page/videoMinitor'
// 导出配置的路由器
export default [{
  // 默认进入此页面
  path: '/operatingCenter',
  component: layout,
  redirect: 'operatingCenter/chargingMonitor',
  meta: {
    title: '运营中心',
    icon: 'icon-yingxiao1',
    perms:['bee:operating']
  },
  children: [
    {
      path: 'chargingMonitor',
      component: chargingMonitor,
      meta: {icon: 'icon-yingxiao1', title: '充电监控',perms:['bee:res:chargingMonitor']}
    }, {
      path: 'siteMonitor',
      component: siteMonitor,
      meta: {icon: 'icon-yunshuchangzhan', title: '场站监控', perms:['bee:order:siteMonitor']}
    },
    {
      path: 'deviceControl',
      component: deviceControl,
      meta: {icon: 'icon-shebei2', title: '设备控制',perms:['bee:res:deviceControl']}
    },
    // {
    //   path: 'videoMinitor',
    //   component: videoMinitor,
    //   meta: {icon: 'icon-shipin1', title: '视频监控'}
    // },
    {
      path: 'alaramMonitor',
      component: () => import("@/module/operatingCenter/page/alarm/alarmManage.vue"),
      meta: {icon: 'icon-gaojing1', title: '告警监控', perms:['bee:ops:alarmRecord']}
    },
    {
      path: 'paramMonitor',
      component: () => import("@/module/operatingCenter/page/param/paramManage.vue"),
      meta: {icon: 'icon-caozuo', title: '参数设置', perms:['bee:ops:paramControl']}
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/module/operatingCenter/router/index.js